import React from 'react';

/**
 * One cell in a challenge summary grid.
 * Value, unit, and label always occupy the same rows so neighboring cells line up.
 */
export const ChallengeStat = ({
    label,
    value,
    unit,
    tone,
    meter,
    metered = false,
    active = false,
    onClick,
    ...rest
}) => {
    const Tag = onClick ? 'button' : 'div';
    const className = [
        'ch-stat',
        tone ? `ch-stat--${tone}` : '',
        active ? 'is-active' : '',
        onClick ? 'ch-stat--button' : '',
    ].filter(Boolean).join(' ');

    return (
        <Tag
            type={onClick ? 'button' : undefined}
            className={className}
            onClick={onClick}
            {...rest}
        >
            <span className="ch-stat-value">{value}</span>
            <span className="ch-stat-unit">{unit || '\u00a0'}</span>
            {(metered || meter != null) && (
                <span className={`ch-stat-meter${meter != null ? ' is-active' : ''}`} aria-hidden="true">
                    {meter != null && (
                        <span
                            className="ch-stat-meter-fill"
                            style={{ width: `${Math.min(100, Math.max(0, meter))}%` }}
                        />
                    )}
                </span>
            )}
            <span className="ch-stat-label">{label}</span>
        </Tag>
    );
};

const ChallengeStatGrid = ({ stats, label = 'Summary', compact = false, className = '' }) => {
    const metered = stats.some((stat) => stat.meter != null);
    return (
        <section
            className={`ch-stats${compact ? ' ch-stats--compact' : ''}${className ? ` ${className}` : ''}`}
            aria-label={label}
        >
            {stats.map((stat) => (
                <ChallengeStat
                    key={stat.label}
                    {...stat}
                    metered={metered}
                />
            ))}
        </section>
    );
};

export default ChallengeStatGrid;
